import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notificationssssss',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
